if (!customElements.get('customer-experience')) {
  class ToggleBlock extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const button = this.querySelector('button');
      const wrapper = this.querySelector('.block-wrapper');

      if (!button || !wrapper) return; 

      button.addEventListener('click', () => {
        const isActive = wrapper.classList.toggle('active');
        button.innerHTML = isActive
          ? `
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <title>Minus</title>
              <rect x="10" y="4" width="2" height="10" transform="rotate(90 10 4)" fill="currentColor"></rect>
            </svg> More less
          `
          : `
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <title>Plus</title>
              <rect x="4" width="2" height="10" fill="currentColor"></rect>
              <rect x="10" y="4" width="2" height="10" transform="rotate(90 10 4)" fill="currentColor"></rect>
            </svg> Show more
          `;
      });
    }
  }

  customElements.define('customer-experience', ToggleBlock);
}







if (!customElements.get('dropdown-box')) {
  class ToggleBlock extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const dropdown_box = this.querySelector('.dropdown-box');
      const sidebar_top = this.querySelector('.sidebar-top');

      if (!dropdown_box || !sidebar_top) return; 

      dropdown_box.addEventListener('click', () => {
        this.querySelector('.svg').classList.toggle ('transform-180');
        const isActive = sidebar_top.classList.toggle('active');
        button.innerHTML = isActive

      });
    }
  }

  customElements.define('dropdown-box', ToggleBlock);
}





if (!customElements.get('faq-wrap')) {
  class ToggleBlock extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const accSingleTriggers = document.querySelectorAll('.js-acc-single-trigger');

      // Open the first FAQ item by default
      const firstItem = document.querySelector('.js-acc-item');
      if (firstItem) {
        const firstContent = firstItem.querySelector('.accordion-single-content');
        firstItem.classList.add('is-open');
        if (firstContent) {
          firstContent.style.maxHeight = firstContent.scrollHeight + "px";
        }
      }

      accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));

      function toggleAccordion() {
        const items = document.querySelectorAll('.js-acc-item');
        const thisItem = this.parentNode;

        items.forEach(item => {
          const content = item.querySelector('.accordion-single-content');

          if (item === thisItem) {
            item.classList.toggle('is-open');
            if (content) {
              content.style.maxHeight = item.classList.contains('is-open') ? content.scrollHeight + "px" : "0";
            }
          } else {
            item.classList.remove('is-open');
            if (content) {
              content.style.maxHeight = "0";
            }
          }
        });
      }
    }
  }

  customElements.define('faq-wrap', ToggleBlock);
}
